module.exports = __webpack_public_path__ + "img/52.5074ba87.jpg";